<template>
    <div v-if="currentApp" class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col cols="12" md="10">
                    <b-link :to="{ name: 'apps' }"
                        ><font-awesome-icon icon="arrow-left" />
                        {{ $t("Back") }}
                    </b-link>
                    <small class="float-right">v{{ currentApp.package.version }}</small>
                    <h1 class="mt-1">
                        {{ currentApp.name }}
                    </h1>
                    <hr />

                    <component
                        :is="currentApp.components.settings"
                        v-if="!isLoading"
                        :app="currentApp"
                        :app-data="appData"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { BButton, BCol, BContainer, BLink, BRow } from "bootstrap-vue";
import { computed } from "@vue/composition-api/dist/vue-composition-api";
import { useRouter } from "@core/utils/utils";

import { useApps } from "@/composables/useApps";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import useAppData from "@/views/components/inbox/active-chat-sidebars/useAppData";
import { onBeforeMount, onBeforeUnmount, onBeforeUpdate } from "@vue/composition-api";

export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BButton,
        BLink,
    },
    setup(props, { emit }) {
        const { route } = useRouter();
        const routeParams = computed(() => route.value.params);

        const toast = useToast();
        const { register, apps } = useApps();
        const currentApp = computed(() => apps.value.find((app) => app.name === routeParams.value.appName));
        const { appData, setActiveApp, isLoading: appDataIsLoading } = useAppData();

        const updateApp = () => {
            setActiveApp(currentApp.value?.id);
            currentApp.value?.utils.setEmitAndToast(emit, toast);
        };

        onBeforeMount(updateApp);
        onBeforeUpdate(updateApp);
        onBeforeUnmount(() => {
            setActiveApp(null);
        });

        const fetchApps = () => {
            axios
                .get("/apps", {
                    params: {
                        fields: "name,enabled,packageName",
                        s: { $or: [{ name: routeParams.value.appName }, { id: routeParams.value.appName }] },
                    },
                })
                .then((response) => {
                    // Only registerihng single app, so dont mark apps as Loaded.
                    register(response.data, false, emit, toast);
                });
        };

        fetchApps();

        return {
            appData,
            apps,
            isLoading: computed(() => appDataIsLoading.value),
            routeParams,
            currentApp,
        };
    },
};
</script>
